import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';

interface Usuario {
  id: number;
  nome: string;
  login: string;
  cnpj: string;
  ativo: boolean;
}

@Component({
  selector: 'app-cadastro-usuario-cliente',
  templateUrl: './cadastro-usuario-cliente.component.html',
  styleUrls: ['./cadastro-usuario-cliente.component.scss']
})
export class CadastroUsuarioClienteComponent implements OnInit {
  usuarioForm: FormGroup;
  usuarios: Usuario[] = [];
  isEditing = false;
  dtOptions: DataTables.Settings = {};

  constructor(private fb: FormBuilder) {
    this.usuarioForm = this.fb.group({
      nome: ['', [Validators.required]],
      login: ['', [Validators.required]],
      cnpj: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      language: {
        url: '//cdn.datatables.net/plug-ins/1.13.7/i18n/pt-BR.json'
      }
    };
    this.carregarUsuarios();
  }

  carregarUsuarios() {
    // Implementar chamada à API
    this.usuarios = [
      {
        id: 1,
        nome: 'Hospital São Lucas',
        login: 'hosp.saolucas',
        cnpj: '00.000.000/0001-00',
        ativo: true
      },
      {
        id: 2,
        nome: 'Clínica Saúde Total',
        login: 'clin.saudetotal',
        cnpj: '00.000.000/0002-00',
        ativo: true
      },
      {
        id: 3,
        nome: 'Laboratório Diagnóstico',
        login: 'lab.diagnostico',
        cnpj: '00.000.000/0003-00',
        ativo: false
      },
      {
        id: 4,
        nome: 'Centro Médico Esperança',
        login: 'centro.esperanca',
        cnpj: '00.000.000/0004-00',
        ativo: true
      },
      {
        id: 5,
        nome: 'Farmácia Vida',
        login: 'farm.vida',
        cnpj: '00.000.000/0005-00',
        ativo: true
      },
      {
        id: 6,
        nome: 'Consultório Odontológico',
        login: 'odont.consult',
        cnpj: '00.000.000/0006-00',
        ativo: false
      },
      {
        id: 7,
        nome: 'Clínica de Fisioterapia',
        login: 'fisio.clinica',
        cnpj: '00.000.000/0007-00',
        ativo: true
      },
      {
        id: 8,
        nome: 'Centro de Imagem',
        login: 'img.centro',
        cnpj: '00.000.000/0008-00',
        ativo: true
      }
    ];
  }

  toggleEdit() {
    this.isEditing = !this.isEditing;
    if (!this.isEditing) {
      this.usuarioForm.reset();
    }
  }

  onSubmit() {
    if (this.usuarioForm.valid) {
      // Implementar chamada à API
      console.log('Salvar usuário:', this.usuarioForm.value);
      this.isEditing = false;
      this.usuarioForm.reset();
      this.carregarUsuarios();
    }
  }

  editarUsuario(usuario: Usuario) {
    this.isEditing = true;
    this.usuarioForm.patchValue({
      nome: usuario.nome,
      login: usuario.login,
      cnpj: usuario.cnpj
    });
  }

  inativarUsuario(usuario: Usuario) {
    // Implementar chamada à API
    console.log('Alterar status do usuário:', {
      id: usuario.id,
      ativo: !usuario.ativo
    });
    usuario.ativo = !usuario.ativo;
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    // Implementar lógica de upload do arquivo
    console.log('Arquivo selecionado:', file);
  }
} 